import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { ProOnly } from '../label/ProOnly';

import { Icon } from '@iconify/react';
import checkboxBlankOutline from '@iconify/icons-mdi/checkbox-blank-outline';
import checkboxMarked from '@iconify/icons-mdi/checkbox-marked';

/**
 * @param {string} id
 * @param {string} name
 * @param   {bool} checked
 * @param {string} label
 * @param {string} description
 */
const StyledNekoCheckbox = Styled(props => {
  const { id, name, checked = false, onChange, label, description, isPro, requirePro = false } = props;

  const showUpProOnly = requirePro && !isPro;
  const disabledClass = showUpProOnly ? 'disabled' : '';

  const onClick = () => {
    if (!onChange) {
      console.log(`The onChange handler it not set for this checkbox.`, props);
      return;
    }
    onChange(id, !checked);
  };

  return (
    <div className={['nui-checkbox', props.className, disabledClass].join(' ')}>
      <input id={id} name={name} type="checkbox" defaultChecked={false} onClick={onClick} disabled={showUpProOnly} />
      <label htmlFor={id}>
      <div className="nui-checkbox-check-container">
        <Icon icon={checked ? checkboxMarked : checkboxBlankOutline} width="30px" height="30px" color={showUpProOnly ? Theme.disabledForm : Theme.blue} />
      </div>
      <div className="nui-checkbox-inner-container">
        <span className="label">{label}<ProOnly className="inline" show={showUpProOnly} /></span>
        {description ? <small className="description">{description}</small> : null}
      </div>
      </label>
    </div>
  );
})`
  font-family: ${Theme.fontFamily};

  &.disabled {
    color: ${Theme.disabledForm};

    label {
      cursor: default;
    }
  }

  input {
    display: none;
  }

  label {
    cursor: pointer;
    display: flex;
  }
  .nui-checkbox-check-container {
    flex-basis: 30px;
  }
  .nui-checkbox-inner-container {
    margin-top: 1.5px;
    margin-left: 4px;

    .label {
      display: block;
      font-size: 14px;
      line-height: 17px;
      padding-top: 4.5px;
      padding-bottom: 4px;
    }
    .description {
      display: block;
      font-size: 12px;
      * {
        font-size: 12px;
        line-height: inherit;
        margin: 0;
      }
    }
  }
`;

const NekoCheckbox = (props) => {
  return (<StyledNekoCheckbox {...props} />);
}

NekoCheckbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
  description: PropTypes.string,
  isPro: PropTypes.bool,
  requirePro: PropTypes.bool
};

NekoCheckbox.defaultProps = {
  id: undefined,
  name: undefined,
  checked: false,
  label: undefined,
  description: undefined,
  isPro: false,
  requirePro: false
};

export { NekoCheckbox };
